import { Button } from "antd";
import clsx from "clsx";
import "./styles.css";

export const StyledButton = ({
  children,
  disabled = false,
  onClick = undefined,
  className = "styled-button",
  variant = "primary",
  ...props
}) => {
  return (
    <Button
      disabled={disabled}
      onClick={onClick}
      type={"primary"}
      className={clsx("styled-button", className, `styled-button-${variant}`)}
      {...props}
    >
      <span className="styled-button-text p-2"> {children}</span>
    </Button>
  );
};
